import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../../components/Navbar';
import '../../components/Navbar.css';
import { getToken, fetchCurrentUser, removeToken } from '../../utils/auth';
import AdminSidebar from '../../components/AdminSidebar';

function AdminIndex() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const check = async () => {
      const token = getToken();
      if (!token) {
        navigate('/admin/login');
        return;
      }
      const current = await fetchCurrentUser();
      if (!current) {
        // Invalid token
        removeToken();
        navigate('/admin/login');
        return;
      }
      setUser(current);
      setLoading(false);
    };
    check();
  }, [navigate]);

  if (loading) return (
    <div style={{ background: '#fff', minHeight: '100vh' }}>
      <Navbar />
  <div style={{ display: 'flex', maxWidth: '1000px', margin: '8px auto' }}>
        <AdminSidebar />
        <main style={{ flex: 1, padding: '12px' }}>Loading admin...</main>
      </div>
    </div>
  );

  return (
    <div style={{ background: '#fff', minHeight: '100vh', color: '#000' }}>
      <Navbar />
  <div style={{ display: 'flex', maxWidth: '1000px', margin: '8px auto' }}>
        <AdminSidebar />
        <main style={{ flex: 1, padding: '12px' }}>
          <section style={{ padding: '10px 12px', borderRadius: 12, boxShadow: '0 1px 6px rgba(16,24,40,0.04)' }}>
            <h2 style={{ marginTop: 0 }}>Admin Dashboard</h2>
            <p>Welcome, {user && (user.name || user.email)}</p>
            <p>This area is restricted to administrators. Add admin tools here.</p>
          </section>
        </main>
      </div>
    </div>
  );
}

export default AdminIndex;
